/**
 * Flag codes — identical to the `graphics-src/score/public/assets/flags/4x3/{code}.svg`
 * set (flag-icons v7.5.0). The list is generated from that folder by
 * `scripts/gen-flags.mjs` — DO NOT EDIT BY HAND.
 */

// >>> gen-flags: boshlanishi
const CODES =
  "ad ae af ag ai al am ao aq ar arab as asean at au aw ax az ba bb bd be bf bg bh bi bj bl bm bn bo bq br bs bt bv bw by bz ca cc cd cefta cf cg ch ci ck cl cm cn co cp cr cu cv cw cx cy cz de dg dj dk dm do dz eac ec ee eg eh er es es-ct es-ga es-pv et eu fi fj fk fm fo fr ga gb gb-eng gb-nir gb-sct gb-wls gd ge gf gg gh gi gl gm gn gp gq gr gs gt gu gw gy hk hm hn hr ht hu ic id ie il im in io iq ir is it je jm jo jp ke kg kh ki km kn kp kr kw ky kz la lb lc li lk lr ls lt lu lv ly ma mc md me mf mg mh mk ml mm mn mo mp mq mr ms mt mu mv mw mx my mz na nc ne nf ng ni nl no np nr nu nz om pa pc pe pf pg ph pk pl pm pn pr ps pt pw py qa re ro rs ru rw sa sb sc sd se sg sh sh-ac sh-hl sh-ta si sj sk sl sm sn so sr ss st sv sx sy sz tc td tf tg th tj tk tl tm tn to tr tt tv tw tz ua ug um un us uy uz va vc ve vg vi vn vu wf ws xk xx ye yt za zm zw";
// <<< gen-flags: oxiri

export const FLAG_CODES: ReadonlySet<string> = new Set(CODES.split(" "));

/** Folder holding the flag SVGs (relative, given the graphic's `base: "./"`). */
export const FLAG_DIR = "assets/flags/4x3";

/**
 * Converts a PFL `citizenship` value to a flag code. `null` — no flag is
 * shown: a local player (UZ) or a code that is missing from the set/non-standard.
 */
export function flagCode(citizenship: string | null | undefined): string | null {
  if (!citizenship) return null;
  const code = citizenship.trim().toLowerCase();
  if (code === "uz") return null;
  return FLAG_CODES.has(code) ? code : null;
}

/** Relative SVG path inside the graphic for a flag code. */
export function flagUrl(code: string): string {
  return `${FLAG_DIR}/${code}.svg`;
}
